export default "/fonts/SofiaSans-300-Light.woff2?5c6fba7de5699edf1e2badd01cfdb30c";